// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.31.1
// source: Common/CardAssignmentEvents.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "common.events";

/** Card assignment events and RFID card event */
export interface CardAssignmentVerificationEvent {
  success: boolean;
  status: string;
  expiresAt: number;
}

export interface CardAssignmentConfirmationEvent {
  success: boolean;
}

export interface CardAssignmentCancelationEvent {
  success: boolean;
}

function createBaseCardAssignmentVerificationEvent(): CardAssignmentVerificationEvent {
  return { success: false, status: "", expiresAt: 0 };
}

export const CardAssignmentVerificationEvent = {
  encode(message: CardAssignmentVerificationEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.status !== "") {
      writer.uint32(18).string(message.status);
    }
    if (message.expiresAt !== 0) {
      writer.uint32(24).int64(message.expiresAt);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CardAssignmentVerificationEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCardAssignmentVerificationEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.status = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.expiresAt = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CardAssignmentVerificationEvent {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      expiresAt: isSet(object.expiresAt) ? globalThis.Number(object.expiresAt) : 0,
    };
  },

  toJSON(message: CardAssignmentVerificationEvent): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.expiresAt !== 0) {
      obj.expiresAt = Math.round(message.expiresAt);
    }
    return obj;
  },

  create(base?: DeepPartial<CardAssignmentVerificationEvent>): CardAssignmentVerificationEvent {
    return CardAssignmentVerificationEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CardAssignmentVerificationEvent>): CardAssignmentVerificationEvent {
    const message = createBaseCardAssignmentVerificationEvent();
    message.success = object.success ?? false;
    message.status = object.status ?? "";
    message.expiresAt = object.expiresAt ?? 0;
    return message;
  },
};

function createBaseCardAssignmentConfirmationEvent(): CardAssignmentConfirmationEvent {
  return { success: false };
}

export const CardAssignmentConfirmationEvent = {
  encode(message: CardAssignmentConfirmationEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CardAssignmentConfirmationEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCardAssignmentConfirmationEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CardAssignmentConfirmationEvent {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: CardAssignmentConfirmationEvent): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<CardAssignmentConfirmationEvent>): CardAssignmentConfirmationEvent {
    return CardAssignmentConfirmationEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CardAssignmentConfirmationEvent>): CardAssignmentConfirmationEvent {
    const message = createBaseCardAssignmentConfirmationEvent();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseCardAssignmentCancelationEvent(): CardAssignmentCancelationEvent {
  return { success: false };
}

export const CardAssignmentCancelationEvent = {
  encode(message: CardAssignmentCancelationEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CardAssignmentCancelationEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCardAssignmentCancelationEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CardAssignmentCancelationEvent {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: CardAssignmentCancelationEvent): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<CardAssignmentCancelationEvent>): CardAssignmentCancelationEvent {
    return CardAssignmentCancelationEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CardAssignmentCancelationEvent>): CardAssignmentCancelationEvent {
    const message = createBaseCardAssignmentCancelationEvent();
    message.success = object.success ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
